module.exports = __webpack_public_path__ + "static/media/startpage-image.763aa8a8.png";